module.exports = __webpack_public_path__ + "static/media/human-ear.0abe9f31.png";